import React from "react";
import {
  Col,
  Image,
  Row,
  //   theme,
} from "antd";
import InventoryLogo from "../../assets/images/inventory.webp";

const Inventory = () => {
  return (
    <React.Fragment>
      <Col span={24} className="mt-[50px] mb-[50px]">
        <Row>
          <Col span={12} className="mt-6">
            <h1 className="text-start leading-tight text-[#314259] text-[48px] font-extrabold">
              Manage Inventory Seamlessly
            </h1>
            <p className="mt-6 text-start text-[#787878] text-[20px] font-semibold">
              Mbook brings the finest inventory management software with
              incredibly effective features. It helps improve business
              performance. Using the Mbook app features like business reports,
              you can track your business's sales. It will help understand how
              effectively you have managed your inventory.
            </p>
          </Col>
          <Col span={12}>
            <Image src={InventoryLogo} height={350} width={450} preview={false} />
          </Col>
        </Row>
      </Col>
    </React.Fragment>
  );
};
export default Inventory;
